<template>
  <nav>
    <v-app-bar app clipped>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text">
        <span class="font-weight-light">NODE</span>
        <span>LEDGE</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      class="primary"
      src="bg-3.jpg"
      temporary
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title white--text">
              <span class="font-weight-light">NODE</span>
              <span>LEDGE</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          v-for="link in viewableLinks"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              link.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item v-if="allowed(null, Roles.SuperAdmin)">
          <v-list-item-content>
            <v-select
              :loading="companyStatus.loading"
              :items="companies"
              item-value="companyId"
              item-text="companyName"
              v-model="currentCompany"
              @change="setCompany"
              return-object
            />
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-switch
              :label="$t('common.darkTheme')"
              v-model="darkTheme"
            ></v-switch>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "NavBar",

  props: ["dark"],

  sync: true,

  data() {
    return {
      drawer: false,
      darkTheme: this.$vuetify.theme.dark,
      currentCompany: {},
      currCompanySet: false,
    };
  },
  computed: {
    ...mapState("users", ["currentUser", "status", "userCompany"]),
    ...mapState("companies", {
      companies: "companies",
      companyStatus: "status",
    }),

    viewableLinks() {
      var links = [];
      if (this.status.loggedIn) {
        var authLinks = this.authLinks.filter((l) => {
          var role = this.currentUser.role;

          return l.role.includes(role);
        });

        links = links.concat(authLinks);
      } else {
        links = this.guestLinks;
      }

      return links;
    },

    guestLinks() {
      return [
        {
          icon: "mdi-home",
          text: this.$t("routes.home"),
          route: "/",
          role: [this.Roles.Guest],
        },
        {
          icon: "mdi-login",
          text: this.$t("routes.login"),
          route: "/login",
          role: [this.Roles.Guest],
        },

        {
          icon: "mdi-account-plus",
          text: this.$t("routes.register"),
          route: "/register",
          role: [this.Roles.Guest],
        },
      ];
    },

    authLinks() {
      return [
        {
          icon: "mdi-home",
          text: this.$t("routes.home"),
          route: "/",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.User,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.Guest,
          ],
        },

        {
          icon: "mdi-radiobox-marked",
          text: this.$t("routes.live"),
          route: "/live",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.User,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
          ],
        },

        {
          icon: "mdi-domain",
          text: this.$t("routes.company"),
          route: "/company",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.User,
          ],
        },

        {
          icon: "mdi-cellphone-link",
          text: this.$t("routes.devices"),
          route: "/device",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.User,
          ],
        },

        {
          icon: "mdi-cellphone-link",
          text: this.$t("routes.devicePool"),
          route: "/pool",
          role: [this.Roles.SuperAdmin],
        },

        {
          icon: "mdi-focus-field-horizontal",
          text: this.$t("routes.deviceFields"),
          route: "/device/fields",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.User,
          ],
        },

        {
          icon: "mdi-cast-connected",
          text: this.$t("routes.connectors"),
          route: "/connectors",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
          ],
        },

        {
          icon: "mdi-account-box",
          text: this.$t("routes.contact"),
          route: "/contact",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.User,
          ],
        },

        {
          icon: "mdi-logout",
          text: this.$t("routes.logout"),
          route: "/logout",
          role: [
            this.Roles.SuperAdmin,
            this.Roles.User,
            this.Roles.Admin,
            this.Roles.CompanyAdmin,
            this.Roles.Guest,
          ],
        },
      ];
    },
  },

  methods: {
    ...mapActions("companies", ["getAll"]),
    ...mapActions("users", ["changeCompanySuperAdmin"]),

    async setCompany(c) {
      if (this.userCompany.companyId != c.companyId) {
        await this.changeCompanySuperAdmin(c);
        this.$router.go();
      }
    },
  },

  async created() {
    if (this.allowed(null, this.Roles.SuperAdmin)) {
      await this.getAll();
      this.currentCompany = this.userCompany;
    }
  },

  watch: {
    darkTheme(v) {
      this.$vuetify.theme.dark = v;

      return this.$vuetify.theme.dark;
    },
  },
};
</script>

<style></style>
